const mapOverrideStage = overrideStages => {
  const overrideStage = overrideStages[0].stage.name;
  return overrideStage;
};

export default mapOverrideStage;
